<div class="pilot-pay-dashboard">
	<div fxLayout="row">
		<div
			fxFlex.sm="100"
			fxFlex.xs="100"
			fxFlex.md="60"
			fxFlex.lg="60"
			fxFlex.xl="60"
			fxFlex="100"
			class="m-gap p-gap"
		></div>
	</div>
	<div fxLayout="row wrap">
		<div
			fxFlex.sm="100"
			fxFlex.xs="100"
			fxFlex.md="50"
			fxFlex.lg="50"
			fxFlex.xl="50"
			fxFlex="100"
			class="m-gap p-gap"
		>
			<app-time-sheet-card [employeeId]="employeeId"></app-time-sheet-card>
		</div>
		<div
			fxFlex.sm="100"
			fxFlex.xs="100"
			fxFlex.md="50"
			fxFlex.lg="50"
			fxFlex.xl="50"
			fxFlex="100"
			class="m-gap p-gap"
		>
			<mat-card *ngIf="timeSheet" class="overview-card total-table-border">
				<mat-card-header
					*ngIf="
						timeSheet?.status !== timeSheetStatusEnum.NotStarted &&
						timeSheet?.status !== timeSheetStatusEnum.InProgress
					"
					class="overview-card-header"
					fxLayout="row wrap"
				>
					<h3 class="text-center font-weight-bold my-xs">
						<span class="readonly-label">Previous Time Sheet</span>
						({{ timeSheet?.startDate | date: 'MMMM, yyyy' }})
					</h3>
				</mat-card-header>

				<mat-card-header
					*ngIf="
						timeSheet?.status === timeSheetStatusEnum.NotStarted ||
						timeSheet?.status === timeSheetStatusEnum.InProgress
					"
					class="warning-card-header"
					fxLayout="row wrap"
				>
					<mat-icon class="deadline-icon" mat-list-icon>warning</mat-icon>
					<h3 class="text-center font-weight-bold my-xs">
						<span *ngIf="isWarningTimeRange" class="read-label ml-1"
							>{{ timeSheet?.startDate | date: 'MMMM' }}
							<span *ngIf="tsSubmissionDeadline == 1">
								Time Sheet is due in <span class="font-bold"> {{ tsSubmissionDeadline }} Day</span>
							</span>
							<span *ngIf="tsSubmissionDeadline == 0">
								Time Sheet is due <span class="font-bold"> today </span></span
							>
							<span *ngIf="tsSubmissionDeadline > 1">
								Time Sheet is due in <span class="font-bold"> {{ tsSubmissionDeadline }} Days</span>
							</span>
						</span>
						<span *ngIf="isAfterDeadlineWarning" class="read-label ml-1"
							>{{ timeSheet?.startDate | date: 'MMMM' }} Time Sheet passed due date</span
						>
					</h3>
				</mat-card-header>
				<mat-card-content class="card-content no-padding pa-1">
					<mat-list>
						<mat-list-item>
							<div fxFlex="33.33%" class="text-center">
								<h5 mat-line class="font-weight-bold ma-0">{{ timeSheet.trips.length }}</h5>
								<p mat-line class="readonly-label no-margin-tb">Trips</p>
							</div>
							<div fxFlex="33.33%" class="text-center">
								<h5 mat-line class="font-weight-bold ma-0">
									{{ timeSheet.totals.totalOfHoursSummary.total | hoursMinutes }}
								</h5>
								<p mat-line class="readonly-label no-margin-tb">Flight Hours</p>
							</div>
							<div fxFlex="33.33%" class="text-center">
								<h5 mat-line class="font-weight-bold ma-0">
									{{ timeSheet.totals.totalOfHoursSummary.overGuaranteedHours | hoursMinutes }}
								</h5>
								<p mat-line class="readonly-label no-margin-tb">Hours Over Guaranteed</p>
							</div>
						</mat-list-item>
						<mat-list-item class="mt-3">
							<div fxFlex="33.33%" class="text-center">
								<h5 mat-line class="font-weight-bold ma-0">
									{{ timeSheet.totals.totalOfPayVariablesTotals.total | currency }}
								</h5>
								<p mat-line class="readonly-label no-margin-tb">Total Pay</p>
							</div>
							<div fxFlex="33.33%" class="text-center">
								<span class="notStarted" *ngIf="timeSheet?.status === timeSheetStatusEnum.NotStarted">
									Not Started
								</span>
								<span class="inProgress" *ngIf="timeSheet?.status === timeSheetStatusEnum.InProgress">
									In Progress
								</span>
								<span
									class="submitTimeSheet"
									*ngIf="timeSheet?.status === timeSheetStatusEnum.SubmittedByEmployee"
								>
									Submitted for approval
								</span>
								<span
									class="approved"
									*ngIf="timeSheet?.status === timeSheetStatusEnum.ApprovedByAdmin"
								>
									Approved
								</span>
								<span class="paid" *ngIf="timeSheet?.status === timeSheetStatusEnum.Paid">
									Paid
								</span>
							</div>
							<div fxFlex="33.33%"></div>
						</mat-list-item>
					</mat-list>
				</mat-card-content>

				<mat-card-actions class="card-action-box">
					<button color="primary" mat-button>
						<span class="font-size" (click)="navigate(timeSheet.employeeId)">
							<span *ngIf="timeSheet?.status === timeSheetStatusEnum.Paid || isAfterDeadlineWarning"
								>View</span
							>
							<span *ngIf="timeSheet?.status !== timeSheetStatusEnum.Paid && !isAfterDeadlineWarning"
								>Edit</span
							>
						</span>
					</button>
				</mat-card-actions>
			</mat-card>
		</div>
	</div>
</div>
